"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Item_1 = __importDefault(require("./Item"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var Conditions = function (_a) {
    var _b;
    var id = _a.id, baseLottery = _a.baseLottery;
    var t = (0, next_intl_1.useTranslations)('lottery');
    var data = (0, swr_hooks_1.useLotteryTicketsHistory)({ lotteryId: id }).data;
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var ticketPrice = (0, react_1.useMemo)(function () {
        var _a, _b;
        return (_b = (_a = baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.depositSettings) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.currency === currentCurrency; })) === null || _b === void 0 ? void 0 : _b.price;
    }, [currentCurrency, baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.depositSettings]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: {
            gridTemplateColumns: "repeat(".concat(ticketPrice && (data === null || data === void 0 ? void 0 : data.length) && (data === null || data === void 0 ? void 0 : data.length) > 0
                ? 3
                : (ticketPrice && (data === null || data === void 0 ? void 0 : data.length) === 0) ||
                    ((data === null || data === void 0 ? void 0 : data.length) && (data === null || data === void 0 ? void 0 : data.length) > 0 && !ticketPrice)
                    ? 2
                    : 1, ", 1fr)"),
        } },
        (data === null || data === void 0 ? void 0 : data.length) && (data === null || data === void 0 ? void 0 : data.length) > 0 ? (react_1.default.createElement(Item_1.default, { image: "/img/icons/lottery/tickets.svg", description: t('yourTickets'), value: (data === null || data === void 0 ? void 0 : data.length) || 0 })) : null,
        react_1.default.createElement(Item_1.default, { image: "/img/icons/lottery/cup.svg", description: t('winners'), value: ((_b = baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.rewards) === null || _b === void 0 ? void 0 : _b.length) || 0 }),
        ticketPrice && (react_1.default.createElement(Item_1.default, { image: "/img/icons/lottery/exchange.svg", description: "1 ".concat(t('ticket')), value: "".concat(ticketPrice, " ").concat(currentCurrency) }))));
};
exports.default = Conditions;
